import resolveZonedTime from "./resolve-zoned-time";

export type ResolveDateOptions<T extends (date: Date, options?: object) => object> = 
  (Parameters<T>[1] extends undefined ? object : Parameters<T>[1]) & {
  timezone?: string;
  withoutDateDifference?: boolean;
};

const resolveDate = <T extends (date: Date, options?: object) => Date>(
  func: T,
  date: Date | string | number,
  options?: ResolveDateOptions<T>
) => {
  const optionsSafe = (options ?? {}) as Record<string, unknown>;
  const timezone = optionsSafe.timezone as string | undefined;
  const withoutDateDifference = optionsSafe.withoutDateDifference as boolean | undefined;
  const rest = { ...optionsSafe };
  delete rest.timezone;
  delete rest.withoutDateDifference;

  const zonedDate = resolveZonedTime(date, {
    timezone,
    withoutDateDifference,
  });
  const startDate = func(zonedDate, rest as Parameters<T>[1]);
  const difference = new Date(date).getTime() - zonedDate.getTime();
  return new Date(startDate.getTime() + difference);
};

export default resolveDate;
